import { Store } from '@hkm/store/interfaces/store';

export const selectMenuState = (state: Store) => state.menu.isMenuOpen;
export const selectMenuBehaviour = (state: Store) => state.menu.behaviour;



// WEBPACK FOOTER //
// ./src/components/Menu/domain/selectors.ts